// App modules that an admin can switch on/off (Admin → Modules).
// Keys match public.app_modules (database/2026-11-03_admin.sql).
// `paths` are the route prefixes that belong to the module.
export const MODULES = [
  { key: 'transactions', name: 'Transactions', paths: ['/transactions'] },
  { key: 'wallets', name: 'Wallets', paths: ['/wallets'] },
  { key: 'analysis', name: 'Analysis', paths: ['/analysis'] },
  { key: 'investments', name: 'Investments', paths: ['/investments'] },
  { key: 'insurance', name: 'Insurance', paths: ['/insurance'] },
  { key: 'loans', name: 'Loans', paths: ['/loans'] },
  { key: 'credit-cards', name: 'Credit Cards', paths: ['/credit-cards', '/statements'] },
  { key: 'utilities', name: 'Utilities', paths: ['/utilities'] },
  { key: 'finance-calculator', name: 'Finance Calculator', paths: ['/finance-calculator'] },
];

const matches = (pathname, prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`);

// The module a route belongs to (null for Dashboard, Profile, Admin, …: those can't be switched off)
export const moduleForPath = (pathname) => MODULES.find(m => m.paths.some(p => matches(pathname, p))) || null;
